import { useContactManagementTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { CsvPreviewTable } from './CsvPreviewTable';
export const ExportTemplateCard = ({ actions, csvPreviewItems, name, }) => {
    const { t } = useContactManagementTranslation();
    const errorPreviewItems = csvPreviewItems.filter(({ error }) => error);
    return (React.createElement(Stack, { gap: 2, borderRadius: 1, p: 2, bgcolor: themeColors.surface.tertiary },
        React.createElement(Stack, { alignItems: 'center', direction: 'row', justifyContent: 'space-between' },
            React.createElement(Typography, { variant: 'subtitle2' }, name),
            React.createElement(Stack, { alignItems: 'center', gap: 2, direction: 'row' },
                React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle, component: 'span' },
                    t('export.fields', { count: csvPreviewItems.length }),
                    errorPreviewItems.length ? (React.createElement(Typography, { variant: 'body2', component: 'span', color: themeColors.accent.red.bold },
                        "\u00A0(",
                        t('export.fieldsInvalid', { count: errorPreviewItems.length }),
                        ")")) : undefined),
                React.createElement(Divider, { orientation: 'vertical', flexItem: true }),
                React.createElement(Stack, { direction: 'row' }, actions))),
        React.createElement(Box, { bgcolor: themeColors.surface.secondary, pl: 2, pt: 2, pr: 2, sx: { borderTopLeftRadius: 4, borderTopRightRadius: 4 } },
            React.createElement(CsvPreviewTable, { headingItems: csvPreviewItems }))));
};
